import React, { useContext, useState } from "react"
import { useHistory } from 'react-router-dom';
import FieldItem from "../../../../components/ModalItem/FieldItem"
import Card from "../../../../components/Card/Card"
import Button from "../../../../components/Button"
import { AppContext } from "../../../../contexts/AppContext"
import { showToast, startLoading, stopLoading } from "../../../../services/common-service"
import api from "../../../../factory/api"
import BlipPortalToastTypes from "../../../../constants/blip-portal-toast-types";

const TicketNewComment = ({
    ticket,
    reload
}) => {
    const { user, appInfo } = useContext(AppContext)
    const history = useHistory()

    const [data, setData] = useState({})

    const submit = async () => {
        try {
            startLoading()

            let body = {
                ...data,
                ticketId: ticket.ticketId,
                // ticket,
                author: {
                    name: user.fullName,
                    email: user.email,
                    phone: user.phoneNumber,
                }
            }

            console.log(body)

            await api.post("/tickets/comments", body, {
                headers: {
                    tenantId: appInfo.tenantId
                }
            })

            // history.push(`/ticket/${ticket?.ticketId}`)

            showToast({
                type: BlipPortalToastTypes.SUCCESS,
                message: "Comentário enviado com sucesso"
            })

            setData({})
            reload?.()
        } catch (error) {
            console.error(error)

            showToast({
                type: BlipPortalToastTypes.DANGER,
                message: error?.response?.data?.message || "Ocorreu um erro. Contacte a SharkDev."
            })

            stopLoading()
        } finally {
        }
    }

    return (
        <div>
            <div style={{ marginBottom: 20 }}>
                <bds-typo variant="fs-20" bold="light" margin={false}>Novo comentário</bds-typo>
            </div>

            <Card>
                <div className="flex flex-column" style={{ gap: 20 }}>
                    {[
                        {
                            "label": "Comentário",
                            "name": "comment",
                            "type": "textarea"
                        },
                        {
                            "label": "Arquivos",
                            "name": "files",
                            "type": "file-list"
                        }
                    ].map((field, index) =>
                        <FieldItem
                            key={index}
                            data={data}
                            setData={setData}
                            index={index}
                            field={field}
                            setValue={(key, value) => {
                                setData(data => {
                                    data[key] = value
                                    return { ...data }
                                })
                            }}
                        // isNew={isNew}
                        // externalData={externalData}
                        // setExternalData={setExternalData}
                        />
                    )}

                    <div className="flex justify-end" style={{ gap: 10 }}>
                        <Button
                            variant={"solid"}
                            color="content"
                            text={"Cancelar"}
                            onClick={() => setData({})}
                        // size="short"
                        />

                        <Button
                            variant={"primary"}
                            text={"Enviar"}
                            onClick={() => submit()}
                            disabled={!data?.comment}
                        // size="short"
                        />
                    </div>
                </div>
            </Card>
        </div>
    )
}

export default TicketNewComment